var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.saveBtnShow,
                      expression: "saveBtnShow",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.saveQuotationApply },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.submitBtnShow,
                      expression: "submitBtnShow",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.submitQuotationApply },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "applyInfoForm",
              staticClass: "topform",
              attrs: { "label-width": "120px", model: _vm.searchForm },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单据编号" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.searchForm.applyNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "applyNo", $$v)
                              },
                              expression: "searchForm.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "handle-input",
                              staticStyle: { width: "100%" },
                              attrs: { disabled: true },
                              model: {
                                value: _vm.searchForm.applyType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "applyType", $$v)
                                },
                                expression: "searchForm.applyType",
                              },
                            },
                            _vm._l(_vm.applyTypeList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建人" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.searchForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "name", $$v)
                              },
                              expression: "searchForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              placeholder: "选择日期",
                              disabled: "",
                            },
                            model: {
                              value: _vm.searchForm.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "createDate", $$v)
                              },
                              expression: "searchForm.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { clearable: "", placeholder: "请输入主题" },
                            model: {
                              value: _vm.searchForm.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "subject", $$v)
                              },
                              expression: "searchForm.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "产品报价明细", name: "first" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.applyLineEdit,
                      expression: "applyLineEdit",
                    },
                  ],
                  staticClass: "toolsBox",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.showApplyLineAddDialogFunc()
                        },
                      },
                    },
                    [_vm._v("新增")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.delSelQuotationApplyLine()
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ],
                1
              ),
              _c(
                "ux-grid",
                {
                  ref: "applyProductTableDataRef",
                  attrs: {
                    data: _vm.applyProductTableData,
                    "keep-source": "",
                    "max-height": "450",
                    "highlight-current-row": "",
                    "show-overflow": "tooltip",
                  },
                },
                [
                  _c("ux-table-column", {
                    attrs: { align: "center", type: "checkbox", width: "80" },
                  }),
                  _c("ux-table-column", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.disableEditor || _vm.searchForm.source !== "SUP",
                        expression: "!disableEditor||searchForm.source!=='SUP'",
                      },
                    ],
                    attrs: { align: "center", title: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-edit-outline",
                              on: {
                                click: function ($event) {
                                  return _vm.onEdit(scope)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      align: "center",
                      title: "序号",
                      type: "index",
                      width: "60",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "eightBitCode",
                      title: "8位码",
                      "min-width": "120",
                      resizable: "",
                      align: "center",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "eightBitCodeName",
                      title: "8位码名称",
                      "min-width": "120",
                      resizable: "",
                      align: "center",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "pickupPoint",
                      title: "提货点",
                      "min-width": "120",
                      resizable: "",
                      align: "center",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "dcName",
                      title: "到货仓库（DC）",
                      "min-width": "200",
                      resizable: "",
                      align: "center",
                    },
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "transportaionMethod",
                      title: "运输方式",
                      "min-width": "120",
                      resizable: "",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("ic")(
                                    scope.row.transportaionMethod,
                                    "COMMON",
                                    "TRANSPORTAION_METHOD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "temperature",
                      title: "温区",
                      "min-width": "100",
                      resizable: "",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("ic")(
                                    scope.row.temperature,
                                    "COMMON",
                                    "TEMPERATURE"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "effectiveBeginDate",
                      title: "产品有效开始日期",
                      "min-width": "180",
                      resizable: "",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.effectiveBeginDate,
                                    "YYYY-MM-DD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "supplierNames",
                      title: "入围供应商",
                      "min-width": "140",
                      resizable: "",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "el-dialog": "",
            title: "8位码选择",
            visible: _vm.dialogVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.materialSearchForm,
                "label-width": "120px",
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "8位码编号:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.eightBitCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "eightBitCode", $$v)
                      },
                      expression: "materialSearchForm.eightBitCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "8位码名称:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.eightBitCodeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.materialSearchForm,
                          "eightBitCodeName",
                          $$v
                        )
                      },
                      expression: "materialSearchForm.eightBitCodeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工厂编号:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.plantNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "plantNo", $$v)
                      },
                      expression: "materialSearchForm.plantNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工厂名称:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.plantName,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "plantName", $$v)
                      },
                      expression: "materialSearchForm.plantName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商编号:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.supplierCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "supplierCode", $$v)
                      },
                      expression: "materialSearchForm.supplierCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "供应商名称:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.supplierName,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "supplierName", $$v)
                      },
                      expression: "materialSearchForm.supplierName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "提货点:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.pickupPoint,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "pickupPoint", $$v)
                      },
                      expression: "materialSearchForm.pickupPoint",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "DC:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.dcName,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "dcName", $$v)
                      },
                      expression: "materialSearchForm.dcName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "温区:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.temperature,
                      callback: function ($$v) {
                        _vm.$set(_vm.materialSearchForm, "temperature", $$v)
                      },
                      expression: "materialSearchForm.temperature",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "运输方式:", size: "small" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.materialSearchForm.transportaionMethod,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.materialSearchForm,
                          "transportaionMethod",
                          $$v
                        )
                      },
                      expression: "materialSearchForm.transportaionMethod",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fatchMaterial()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { attrs: { size: "mini" } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createDetailMateria()
                    },
                  },
                },
                [_vm._v("选择")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "dialogIntable",
              attrs: {
                data: _vm.materialList,
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChangeMateria },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "eightBitCode",
                  sortable: "",
                  label: "8位码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "eightBitCodeName",
                  sortable: "",
                  label: "8位码名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "plantName",
                  sortable: "",
                  label: "对应工厂编号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierCode",
                  sortable: "",
                  label: "供应商编号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "supplierName",
                  sortable: "",
                  label: "供应商名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "dcName",
                  sortable: "",
                  label: "DC",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "temperatureI18n",
                  sortable: "",
                  label: "温区",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "transportaionMethodI18n",
                  sortable: "",
                  label: "运输方式",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcMultipleDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcMultipleDialog = $event
            },
          },
        },
        [
          _c("SelDc", {
            ref: "selectDcMultipleRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectDcMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _c("SelSupplier", {
            ref: "supplierSelRef",
            on: { subCallMethod: _vm.selectSupplierMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价明细",
            visible: _vm.dialogEditVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditVisible = $event
            },
            close: _vm.onCancel,
          },
        },
        [
          _c(
            "el-table",
            {
              ref: "tableDataRef",
              staticClass: "table",
              attrs: {
                "min-height": "450",
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "eightBitCode",
                  label: "8位码",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "eightBitCodeName",
                  label: "8位码名称",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "pickupPoint",
                  label: "提货点",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "dcName",
                  label: "到货仓库（DC）",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-input",
                          {
                            attrs: { "suffix-icon": "el-icon-search" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.showSelDcDialogFunc("1", scope.row)
                              },
                            },
                            model: {
                              value: scope.row.dcName,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "dcName", $$v)
                              },
                              expression: "scope.row.dcName",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "transportaionMethod",
                  label: "运输方式",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticClass: "handle-input",
                            model: {
                              value: scope.row.transportaionMethod,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "transportaionMethod", $$v)
                              },
                              expression: "scope.row.transportaionMethod",
                            },
                          },
                          _vm._l(
                            _vm.transportaionMethodList,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm._f("inputChoiceI18n")(item),
                                  value: item.code,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  sortable: "",
                  prop: "temperature",
                  label: "温区",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.temperature,
                              "COMMON",
                              "TEMPERATURE"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "effectiveBeginDate",
                  label: "产品有效开始日期",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          staticStyle: { width: "80%" },
                          attrs: {
                            "picker-options": _vm.pickerOptions,
                            "value-format": "yyyy-MM-dd",
                            type: "date",
                            placeholder: _vm.$t("common.selDate"),
                          },
                          model: {
                            value: scope.row.effectiveBeginDate,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "effectiveBeginDate", $$v)
                            },
                            expression: "scope.row.effectiveBeginDate",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "supplierNames",
                  label: "入围供应商",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-input",
                          {
                            attrs: { "suffix-icon": "el-icon-search" },
                            on: {
                              focus: function ($event) {
                                return _vm.showSelSupplierFunc(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.supplierNames,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "supplierNames", $$v)
                              },
                              expression: "scope.row.supplierNames",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }